import React from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons'

const layoutDesign = () => (

    <table style={{ margin: "0px", fontFamily: "Roboto" }}>
        <tr>
            <td style={{
                border: "none", borderRight: "1px solid rgba(0, 0, 0, 0.125)", width: "80%"
            }}>
                <p style={{ marginBottom: "0px", fontWeight: "bold" }}>Email Design</p>
                <p style={{ marginBottom: "0px", fontWeight: "normal", fontSize: "14px" }}>Our custom Email Designer will work with you to make your vision a reality.  <br /> Designed around responsive screen sizes (Desktop, Tablet, Mobile). <br /> <span style={{ color: "#39ace7", fontWeight: "bold" }}>Unlimited Revisions</span> </p>
            </td>
            <td className="text-center" style={{ border: "none" }}>

                <FontAwesomeIcon icon={faCheck} color="#39ace7" />
            </td>
        </tr>
    </table>

)

export default layoutDesign;